// routes/AnalyticsRouteTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAnalytics } from "../../providers/analyticsProvider";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function AnalyticsRouteTracker() {
    const { pathname, search } = useLocation();
    const { track } = useAnalytics();

    useEffect(() => {
        track({
            eventType: "page_view" as any,
            resourceType: "page",
            resourceId: pathname,
            metadata: { search },
        });
    }, [pathname, search, track]);

    return null;
}
